import React from 'react';
import styled from 'styled-components';
import { RestorativeProgram } from '../../services/Restorative';

import StyledSelect from '../StyledSelect';

interface Props {
  programs: RestorativeProgram[];
  onSelectProgram: (id: number) => void;
}

const SelectWrapper = styled.div`
  display: inline-block;
  margin-bottom: 10px;
  margin-right: 20px;
  text-align: left;
  float: left;
`;

const SelectLabel = styled.label(({ theme }) => {
  return `
        font-size: ${theme.new.type.size[16]};
    `;
});

const RestorativeProgramFilter: React.FC<Props> = ({ programs, onSelectProgram }) => {
  const handleProgramSelection = (programId: string) => {
    const selectedId = parseInt(programId);
    onSelectProgram(selectedId);
  };

  const programsWithAll = [{ id: -1, name: 'Show All' }, ...programs];

  const programOptions = programsWithAll.map((program) => {
    return {
      value: program.id.toString(),
      label: program.name,
    };
  });

  return (
    <SelectWrapper>
      <SelectLabel htmlFor="programFilter">Filter by Assigned Program:</SelectLabel>
      <StyledSelect options={programOptions} updateFunc={handleProgramSelection} />
    </SelectWrapper>
  );
};

export default RestorativeProgramFilter;
